import type { RatingTag } from '@packages/gql/generated/shopping/graphql';
import { Box, Chip, Link } from '@packages/shared';
import { useRouter } from 'next/router';
import { useRatingFilterTag } from '../useRatingFilterTag';

type TagsProps = {
  /**
   * Tags to show in the chip list
   */
  tags: Array<
    Pick<RatingTag, 'ratingCount'> & { tag: Omit<RatingTag['tag'], 'type' | 'userDefined'> }
  >;
};

/**
 * List of linked rating tags
 */
export const Tags = ({ tags }: TagsProps) => {
  const { filterTagFromUrl, noFilterTagUrl, createFilterUrl } = useRatingFilterTag();
  const { pathname } = useRouter();

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, m: 0, p: 0 }} component="ul">
      {tags.map(({ tag, ratingCount }) => (
        // TODO(api-layer): update key field to non-nullable (if it stays nullable, add ConditionalWrapper)
        <Link
          href={
            filterTagFromUrl && filterTagFromUrl === tag.key!
              ? noFilterTagUrl
              : createFilterUrl(tag.key!)
          }
          key={tag.id}
          noLinkStyle
          sx={{ minWidth: 0 }}
          scroll={!pathname.includes('/rating')}
        >
          <Chip
            component="li"
            label={`${tag.name} (${ratingCount})`}
            sx={{ cursor: 'inherit' }}
            color={filterTagFromUrl && filterTagFromUrl === tag.key! ? 'primary' : 'default'}
          />
        </Link>
      ))}
    </Box>
  );
};
